import { OptionSelectionCount, ValidationOperator } from './questionValidationRules.types';

export const VALIDATION_CONSTRAINTS = {
  minSelectedOptions: 1,

  [ValidationOperator.IS_EQUAL]: {
    maxAllowed: (selectionCount: OptionSelectionCount, totalOptions: number): number =>
      selectionCount === 'any' ? totalOptions : selectionCount,
  },

  [ValidationOperator.HAS_ANSWER]: {
    maxAllowed: (selectionCount: OptionSelectionCount, totalOptions: number): number =>
      selectionCount === 'any' ? totalOptions : selectionCount,
  },

  [ValidationOperator.DOES_NOT_HAVE_ANSWER]: {
    maxAllowed: (selectionCount: OptionSelectionCount, totalOptions: number): number =>
      selectionCount === 'any' ? totalOptions - 1 : totalOptions - selectionCount,
  },

  [ValidationOperator.AT_LEAST]: {
    minCountMin: 1,
    minCountMax: (selectionCount: OptionSelectionCount, totalOptions: number): number =>
      selectionCount === 'any' ? totalOptions : Math.min(selectionCount, totalOptions),
  },
} as const;
